import type { Texts } from '../useTexts'

export const createValidateCompanies = (
  texts: Texts,
  companies: uui.domain.client.rm.Company[],
) => {
  const hasError = companies.length === 0

  const companiesRequiredError = {
    id: 'companiesRequiredError',
    message: texts.errors.companies,
    field: 'companies' as const,
    priority: 10,
  }

  return {
    [companiesRequiredError.id]: hasError ? companiesRequiredError : undefined,
  }
}
